import type { CodingAppView } from './coding-events';

/** FRONT-3159: where the header's eye opens. The server sends `draftPreview` only while both preview flags are on. */
export function previewEye(app: Pick<CodingAppView, 'url' | 'viewerIsEditor'> & { draftPreview?: string | null }): { href: string; label: string } {
  // An editor's own draft is the only version of the app they can change; the owner's eye stays on the live app.
  return app.viewerIsEditor && app.draftPreview
    ? { href: app.draftPreview, label: "Preview your draft — how it looks before it's accepted" }
    : { href: app.url, label: 'Preview — open this app in a new tab' };
}

/** FRONT-3159: the owner's own draft, beside the live eye, while both preview flags are on. */
export function ownerDraftLink(app: Pick<CodingAppView, 'viewerIsEditor'> & { draftPreview?: string | null }): string | null {
  return !app.viewerIsEditor && app.draftPreview ? app.draftPreview : null;
}
